import plansListContainer from './plansListContainer';

const module = angular.module('websked.plans', []);

const toLoad = [
  plansListContainer
];

toLoad.forEach(fn => fn(module));

function routes($stateProvider) {
  $stateProvider
    .state('plans', {
      url: '/plans',
      component: 'plansListContainer',
      resolve: {
        $state: [
          '$state',
          $state => $state
        ],
        filtersService: [
          'filtersService',
          filtersService => filtersService
        ],
        platformService: [
          'platformService',
          platformService => platformService
        ],
        siteService: [
          'siteService',
          siteService => siteService
        ],
        websiteHierarchies: [
          'companyService',
          companyService => companyService.get()
            .then(company => company.siteServiceHierarchies || [], () => [])
        ],
        platforms: [
          'platformService',
          platformService => platformService.getAll()
            .then(platforms => platforms, () => null)
        ],
        websites: [
          'siteService',
          siteService => siteService.getWebsites()
            .then(websites => websites, () => null)
        ]
      },
      data: {
        pageTitle: {
          de: 'Pläne',
          en: 'Plans',
          es: 'Planes',
          fr: 'Plans'
        }
      }
    });
}

module.config([
  '$stateProvider',
  routes
]);
